// Mock data for The Navkar Travels by TVL

export const destinations = [
  {
    id: 1,
    name: "Bali, Indonesia",
    description: "Tropical paradise with stunning beaches, temples, and rice terraces",
    image: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=800",
    duration: "5-7 Days",
    type: "Honeymoon, Leisure",
    activities: [
      { id: 1, name: "Snorkeling", description: "Explore vibrant coral reefs and colorful marine life", image: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=400" },
      { id: 2, name: "ATV Ride", description: "Thrilling off-road adventure through rice paddies and villages", image: "https://images.unsplash.com/photo-1558981806-ec527fa84c39?w=400" },
      { id: 3, name: "Bali Swing", description: "Iconic jungle swing experience with breathtaking views", image: "https://images.unsplash.com/photo-1518548419970-58e3b4079ab2?w=400" },
      { id: 4, name: "Scuba Diving", description: "Dive into crystal clear waters and discover underwater wonders", image: "https://images.unsplash.com/photo-1544551763-77ef2d0cfc6c?w=400" },
      { id: 5, name: "Water Sports", description: "Jet ski, parasailing, banana boat & more thrilling activities", image: "https://images.unsplash.com/photo-1530053969600-caed2596d242?w=400" },
      { id: 6, name: "Temple Tour", description: "Visit ancient Balinese temples and learn about Hindu culture", image: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=400" },
      { id: 7, name: "Rice Terrace Walk", description: "Scenic walk through the stunning Tegalalang Rice Terraces", image: "https://images.unsplash.com/photo-1531592937781-344ad608fabf?w=400" },
      { id: 8, name: "Cooking Class", description: "Learn to prepare authentic traditional Balinese cuisine", image: "https://images.unsplash.com/photo-1507048331197-7d4ac70811cf?w=400" },
      { id: 9, name: "Ubud Monkey Forest", description: "Explore the sacred monkey forest sanctuary in Ubud", image: "https://images.unsplash.com/photo-1516426122078-c23e76319801?w=400" },
      { id: 10, name: "Sunset Dinner Cruise", description: "Romantic dinner cruise with stunning Bali sunset views", image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400" },
      { id: 11, name: "Spa & Wellness", description: "Traditional Balinese massage and spa treatments", image: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=400" },
      { id: 12, name: "Waterfall Visit", description: "Trek to beautiful hidden waterfalls in Bali's jungle", image: "https://images.unsplash.com/photo-1494472155656-f34e81b17ddc?w=400" }
    ]
  },
  {
    id: 2,
    name: "Dubai, UAE",
    description: "Luxury and modern marvels in the heart of the desert",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800",
    duration: "4-6 Days",
    type: "Family, Luxury",
    activities: [
      { id: 1, name: "Burj Khalifa", description: "Visit the world's tallest building with stunning city views", image: "https://images.unsplash.com/photo-1582672060674-bc2bd808a8b5?w=400" },
      { id: 2, name: "Desert Safari", description: "Dune bashing, camel ride, BBQ dinner & belly dancing show", image: "https://images.unsplash.com/photo-1451337516015-6b6e9a44a8a3?w=400" },
      { id: 3, name: "Dubai Mall", description: "World's largest shopping mall with aquarium & fountain show", image: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=400" },
      { id: 4, name: "Dubai Marina Cruise", description: "Luxury dhow dinner cruise with spectacular marina views", image: "https://images.unsplash.com/photo-1533395427226-788cee25cc7b?w=400" },
      { id: 5, name: "Ski Dubai", description: "Indoor skiing and snow park experience in the desert", image: "https://images.unsplash.com/photo-1516426122078-c23e76319801?w=400" },
      { id: 6, name: "Gold Souk", description: "Traditional market with finest gold jewelry collections", image: "https://images.unsplash.com/photo-1569288063643-5d29ad64df09?w=400" },
      { id: 7, name: "Atlantis Aquaventure", description: "Thrilling water park with slides, pools & marine encounters", image: "https://images.unsplash.com/photo-1520942702018-0862200e6873?w=400" },
      { id: 8, name: "Dubai Frame", description: "Iconic landmark with panoramic views of old and new Dubai", image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=400" },
      { id: 9, name: "Palm Jumeirah Tour", description: "Explore the iconic palm-shaped island and luxury resorts", image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=400" },
      { id: 10, name: "Hot Air Balloon", description: "Sunrise balloon ride over the Arabian desert landscape", image: "https://images.unsplash.com/photo-1507608616759-54f48f0af0ee?w=400" },
      { id: 11, name: "Helicopter Tour", description: "See Dubai's skyline from above with helicopter ride", image: "https://images.unsplash.com/photo-1565967511849-76a60a516170?w=400" },
      { id: 12, name: "Miracle Garden", description: "World's largest natural flower garden with 150M flowers", image: "https://images.unsplash.com/photo-1490750967868-88aa4486c946?w=400" }
    ]
  },
  {
    id: 3,
    name: "Europe Tour",
    description: "Explore the historic cities and cultures of Europe",
    image: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=800",
    duration: "10-15 Days",
    type: "Group, Adventure",
    activities: [
      { id: 1, name: "Eiffel Tower Visit", description: "Iconic Paris landmark with breathtaking city views", image: "https://images.unsplash.com/photo-1511739001486-6bfe10ce65f4?w=400" },
      { id: 2, name: "Swiss Alps Tour", description: "Spectacular mountain sightseeing with cable cars", image: "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=400" },
      { id: 3, name: "Gondola Ride", description: "Romantic Venice canal experience on traditional boats", image: "https://images.unsplash.com/photo-1534113414509-0eec2bfb493f?w=400" },
      { id: 4, name: "Museum Visits", description: "Louvre, Vatican, British Museum & more cultural icons", image: "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=400" },
      { id: 5, name: "Wine Tasting", description: "French vineyard tour with premium wine sampling", image: "https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?w=400" },
      { id: 6, name: "Castle Tours", description: "Explore historic European castles and palaces", image: "https://images.unsplash.com/photo-1531572753322-ad063cecc140?w=400" },
      { id: 7, name: "City Walking Tours", description: "Guided explorations of Europe's most beautiful cities", image: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=400" },
      { id: 8, name: "River Rhine Cruise", description: "Scenic cruise through Germany's romantic valley", image: "https://images.unsplash.com/photo-1533929736458-ca588d08c8be?w=400" },
      { id: 9, name: "Amsterdam Bike Tour", description: "Explore Amsterdam like a local on two wheels", image: "https://images.unsplash.com/photo-1534351590666-13e3e96b5017?w=400" },
      { id: 10, name: "Barcelona Gothic Quarter", description: "Walk through medieval streets and hidden squares", image: "https://images.unsplash.com/photo-1523531294919-4bcd7c65e216?w=400" },
      { id: 11, name: "Northern Lights", description: "Chase the aurora borealis in Scandinavia", image: "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=400" },
      { id: 12, name: "Greek Island Hopping", description: "Explore stunning Santorini, Mykonos & more islands", image: "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400" }
    ]
  },
  {
    id: 4,
    name: "Singapore",
    description: "Modern city-state with world-class attractions and cuisine",
    image: "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=800",
    duration: "3-5 Days",
    type: "Family, Leisure",
    activities: [
      { id: 1, name: "Universal Studios", description: "Theme park adventure with thrilling rides & shows", image: "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?w=400" },
      { id: 2, name: "Gardens by the Bay", description: "Futuristic garden with Supertrees and Cloud Forest", image: "https://images.unsplash.com/photo-1506351421178-63b52a2d2562?w=400" },
      { id: 3, name: "Sentosa Island", description: "Beach resort with adventure activities & attractions", image: "https://images.unsplash.com/photo-1565967511849-76a60a516170?w=400" },
      { id: 4, name: "Marina Bay Sands", description: "Iconic skypark observation deck with infinity pool", image: "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=400" },
      { id: 5, name: "Singapore Zoo", description: "Award-winning wildlife safari experience", image: "https://images.unsplash.com/photo-1474511320723-9a56873571b7?w=400" },
      { id: 6, name: "Chinatown Tour", description: "Cultural district with temples, markets & food", image: "https://images.unsplash.com/photo-1522547902298-51566e4fb383?w=400" },
      { id: 7, name: "River Cruise", description: "Scenic Singapore River tour past historic landmarks", image: "https://images.unsplash.com/photo-1533929736458-ca588d08c8be?w=400" },
      { id: 8, name: "Night Safari", description: "World's first nocturnal wildlife park", image: "https://images.unsplash.com/photo-1507908708918-778587c9e563?w=400" },
      { id: 9, name: "S.E.A. Aquarium", description: "Marine life park with over 100,000 sea creatures", image: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=400" },
      { id: 10, name: "Hawker Center Food Tour", description: "Taste Singapore's famous street food culture", image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=400" },
      { id: 11, name: "Merlion Park", description: "Visit Singapore's iconic mythical mascot statue", image: "https://images.unsplash.com/photo-1496939376851-89342e90adcd?w=400" },
      { id: 12, name: "Little India Walk", description: "Vibrant ethnic quarter with temples & bazaars", image: "https://images.unsplash.com/photo-1565967511849-76a60a516170?w=400" }
    ]
  },
  {
    id: 5,
    name: "Nepal",
    description: "Himalayan adventures and spiritual experiences",
    image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800",
    duration: "6-8 Days",
    type: "Adventure, Trekking",
    activities: [
      { id: 1, name: "Everest Base Camp Trek", description: "Iconic mountain trek to the foot of world's highest peak", image: "https://images.unsplash.com/photo-1486911278844-a81c5267e227?w=400" },
      { id: 2, name: "Paragliding", description: "Fly over beautiful Pokhara valley with Himalayan backdrop", image: "https://images.unsplash.com/photo-1503220317375-aaad61436b1b?w=400" },
      { id: 3, name: "Bungee Jumping", description: "One of the world's highest bungee jump experiences", image: "https://images.unsplash.com/photo-1524850011238-e3d235c7d4c9?w=400" },
      { id: 4, name: "Temple Visits", description: "Explore sacred Buddhist & Hindu temples in Kathmandu", image: "https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=400" },
      { id: 5, name: "Mountain Biking", description: "Thrilling Himalayan trail biking adventures", image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400" },
      { id: 6, name: "White Water Rafting", description: "Exciting river adventure on Himalayan rapids", image: "https://images.unsplash.com/photo-1530866495561-507c9faab2ed?w=400" },
      { id: 7, name: "Chitwan Safari", description: "Jungle wildlife safari with elephants & rhinos", image: "https://images.unsplash.com/photo-1557008075-7f2c5cea1b89?w=400" },
      { id: 8, name: "Annapurna Circuit", description: "Classic trekking route around Annapurna massif", image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400" },
      { id: 9, name: "Pokhara Lake Tour", description: "Boating on serene Phewa Lake with mountain views", image: "https://images.unsplash.com/photo-1585409677983-0f6c41ca9c3b?w=400" },
      { id: 10, name: "Sunrise at Sarangkot", description: "Watch sunrise over Himalayan peaks from viewpoint", image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=400" },
      { id: 11, name: "Meditation Retreat", description: "Spiritual retreat at Buddhist meditation centers", image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400" },
      { id: 12, name: "Helicopter Tour", description: "Scenic flight over Everest and Himalayan ranges", image: "https://images.unsplash.com/photo-1486870591958-9b9d0d1dda99?w=400" }
    ]
  },
  {
    id: 6,
    name: "Sri Lanka",
    description: "Island paradise with wildlife, beaches, and tea plantations",
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800",
    duration: "5-7 Days",
    type: "Family, Leisure",
    activities: [
      { id: 1, name: "Elephant Safari", description: "Wildlife sanctuary visit to see wild elephants", image: "https://images.unsplash.com/photo-1535941339077-2dd1c7963098?w=400" },
      { id: 2, name: "Tea Plantation Tour", description: "Ceylon tea experience in beautiful hill country", image: "https://images.unsplash.com/photo-1495774539583-885e02cca8c2?w=400" },
      { id: 3, name: "Sigiriya Rock", description: "Climb the ancient rock fortress with frescoes", image: "https://images.unsplash.com/photo-1588598198321-9f5c6d6c8e3c?w=400" },
      { id: 4, name: "Beach Activities", description: "Surfing, snorkeling & water sports in tropical waters", image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400" },
      { id: 5, name: "Whale Watching", description: "Blue whale spotting in Mirissa's deep waters", image: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=400" },
      { id: 6, name: "Galle Fort Tour", description: "Explore historic Dutch colonial fort by the sea", image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400" },
      { id: 7, name: "Scenic Train Ride", description: "Famous Ella to Kandy hill country railway journey", image: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=400" },
      { id: 8, name: "Nine Arch Bridge", description: "Visit iconic colonial-era railway bridge in Ella", image: "https://images.unsplash.com/photo-1586183522805-3fffe5fc7759?w=400" },
      { id: 9, name: "Yala National Park", description: "Leopard safari in Sri Lanka's premier wildlife park", image: "https://images.unsplash.com/photo-1456926631375-92c8ce872def?w=400" },
      { id: 10, name: "Temple of Tooth", description: "Sacred Buddhist temple in Kandy", image: "https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=400" },
      { id: 11, name: "Cooking Class", description: "Learn authentic Sri Lankan curry recipes", image: "https://images.unsplash.com/photo-1507048331197-7d4ac70811cf?w=400" },
      { id: 12, name: "Stilt Fishermen", description: "See traditional fishing method on wooden poles", image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400" }
    ]
  },
  {
    id: 7,
    name: "Malaysia",
    description: "Diverse culture, modern cities, and tropical rainforests",
    image: "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=800",
    duration: "5-7 Days",
    type: "Family, Adventure",
    activities: [
      { id: 1, name: "KL Tower", description: "Kuala Lumpur observation deck with sky deck", image: "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=400" },
      { id: 2, name: "Skyworld Genting", description: "Theme park with exciting rides in highlands", image: "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?w=400" },
      { id: 3, name: "Petronas Towers", description: "Iconic twin towers skybridge experience", image: "https://images.unsplash.com/photo-1508062878650-88b52897f298?w=400" },
      { id: 4, name: "Batu Caves", description: "Hindu temple complex in limestone caves", image: "https://images.unsplash.com/photo-1590125234099-0dbc8f365b57?w=400" },
      { id: 5, name: "Langkawi Cable Car", description: "Mountain top experience with stunning views", image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400" },
      { id: 6, name: "Penang Food Tour", description: "Famous Malaysian street food exploration", image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=400" },
      { id: 7, name: "Jungle Trekking", description: "Rainforest adventure in Taman Negara", image: "https://images.unsplash.com/photo-1448375240586-882707db888b?w=400" },
      { id: 8, name: "Island Hopping", description: "Explore beautiful islands around Langkawi", image: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=400" },
      { id: 9, name: "Georgetown Heritage", description: "UNESCO heritage walk with street art", image: "https://images.unsplash.com/photo-1522547902298-51566e4fb383?w=400" },
      { id: 10, name: "Firefly Tour", description: "Magical night tour to see glowing fireflies", image: "https://images.unsplash.com/photo-1507908708918-778587c9e563?w=400" },
      { id: 11, name: "Aquaria KLCC", description: "Underwater tunnel aquarium experience", image: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=400" },
      { id: 12, name: "Cameron Highlands", description: "Tea plantations and strawberry farms tour", image: "https://images.unsplash.com/photo-1495774539583-885e02cca8c2?w=400" }
    ]
  },
  {
    id: 8,
    name: "Vietnam",
    description: "Rich history, stunning landscapes, and delicious cuisine",
    image: "https://images.unsplash.com/photo-1528127269322-539801943592?w=800",
    duration: "7-10 Days",
    type: "Adventure, Culture",
    activities: [
      { id: 1, name: "Ha Long Bay Cruise", description: "UNESCO heritage cruise among limestone karsts", image: "https://images.unsplash.com/photo-1528127269322-539801943592?w=400" },
      { id: 2, name: "Cu Chi Tunnels", description: "Historic war tunnel network exploration", image: "https://images.unsplash.com/photo-1583417319070-4a69db38a482?w=400" },
      { id: 3, name: "Mekong Delta Tour", description: "Floating markets and river delta exploration", image: "https://images.unsplash.com/photo-1557750255-c76072a7aad1?w=400" },
      { id: 4, name: "Hoi An Old Town", description: "Ancient town with lanterns and tailors", image: "https://images.unsplash.com/photo-1559592413-7cec4d0cae2b?w=400" },
      { id: 5, name: "Street Food Tour", description: "Vietnamese cuisine tasting adventure", image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=400" },
      { id: 6, name: "Motorbike Tour", description: "Countryside exploration on two wheels", image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400" },
      { id: 7, name: "Water Puppet Show", description: "Traditional Vietnamese water puppet performance", image: "https://images.unsplash.com/photo-1567591370504-68137e6ca948?w=400" },
      { id: 8, name: "Sapa Trek", description: "Rice terrace trekking with hill tribe villages", image: "https://images.unsplash.com/photo-1531592937781-344ad608fabf?w=400" },
      { id: 9, name: "Imperial City Hue", description: "Ancient citadel and royal tombs visit", image: "https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=400" },
      { id: 10, name: "Phong Nha Caves", description: "World's largest caves exploration", image: "https://images.unsplash.com/photo-1494472155656-f34e81b17ddc?w=400" },
      { id: 11, name: "Cooking Class", description: "Learn to cook authentic Vietnamese dishes", image: "https://images.unsplash.com/photo-1507048331197-7d4ac70811cf?w=400" },
      { id: 12, name: "Ninh Binh Boat Tour", description: "Scenic boat ride through Tam Coc caves", image: "https://images.unsplash.com/photo-1585409677983-0f6c41ca9c3b?w=400" }
    ]
  }
];

// Pre-built itineraries for each destination
export const itineraries = [
  {
    id: 1,
    destinationId: 1,
    name: "Classic Bali Experience",
    duration: "5 Days",
    days: [
      { day: 1, title: "Arrival & Beach Day", activities: ["Airport pickup", "Beach time", "Sunset dinner"] },
      { day: 2, title: "Temple & Culture", activities: ["Temple Tour", "Rice Terrace Walk", "Cooking Class"] },
      { day: 3, title: "Adventure Day", activities: ["ATV Ride", "Bali Swing", "Ubud Monkey Forest"] },
      { day: 4, title: "Water Activities", activities: ["Snorkeling", "Water Sports", "Spa & Wellness"] },
      { day: 5, title: "Departure", activities: ["Waterfall Visit", "Souvenir shopping", "Airport transfer"] }
    ]
  },
  {
    id: 2,
    destinationId: 1,
    name: "Bali Honeymoon Special",
    duration: "7 Days",
    days: [
      { day: 1, title: "Romantic Welcome", activities: ["Airport pickup", "Private villa check-in", "Candlelight dinner"] },
      { day: 2, title: "Ubud Romance", activities: ["Rice Terrace Walk", "Spa & Wellness", "Romantic dinner"] },
      { day: 3, title: "Adventure Together", activities: ["Bali Swing", "Cooking Class", "Ubud Monkey Forest"] },
      { day: 4, title: "Ocean Day", activities: ["Snorkeling", "Sunset Dinner Cruise", "Beach time"] },
      { day: 5, title: "Temple & Culture", activities: ["Temple Tour", "Traditional dance show", "Sunset views"] },
      { day: 6, title: "Thrill & Chill", activities: ["ATV Ride", "Waterfall Visit", "Spa & Wellness"] },
      { day: 7, title: "Departure", activities: ["Leisurely breakfast", "Souvenir shopping", "Airport transfer"] }
    ]
  },
  {
    id: 3,
    destinationId: 2,
    name: "Dubai Highlights",
    duration: "4 Days",
    days: [
      { day: 1, title: "City Marvels", activities: ["Airport pickup", "Burj Khalifa", "Dubai Mall"] },
      { day: 2, title: "Desert Adventure", activities: ["Desert Safari", "Camel ride", "BBQ dinner"] },
      { day: 3, title: "Water & Wonder", activities: ["Atlantis Aquaventure", "Palm Jumeirah Tour", "Dubai Marina Cruise"] },
      { day: 4, title: "Departure", activities: ["Gold Souk", "Dubai Frame", "Airport transfer"] }
    ]
  },
  {
    id: 4,
    destinationId: 2,
    name: "Dubai Luxury Experience",
    duration: "6 Days",
    days: [
      { day: 1, title: "Grand Arrival", activities: ["Airport pickup", "Luxury hotel check-in", "Dubai Marina Cruise"] },
      { day: 2, title: "Icons & Views", activities: ["Burj Khalifa", "Dubai Frame", "Dubai Mall"] },
      { day: 3, title: "Desert Magic", activities: ["Hot Air Balloon", "Desert Safari", "Desert camp dinner"] },
      { day: 4, title: "Theme Park Day", activities: ["Atlantis Aquaventure", "Beach time", "Palm Jumeirah Tour"] },
      { day: 5, title: "Sky & Snow", activities: ["Helicopter Tour", "Ski Dubai", "Miracle Garden"] },
      { day: 6, title: "Departure", activities: ["Gold Souk shopping", "Brunch", "Airport transfer"] }
    ]
  },
  {
    id: 5,
    destinationId: 3,
    name: "Best of Europe",
    duration: "12 Days",
    days: [
      { day: 1, title: "Paris Arrival", activities: ["Airport pickup", "Seine River walk", "Welcome dinner"] },
      { day: 2, title: "Paris Highlights", activities: ["Eiffel Tower Visit", "Museum Visits", "Wine Tasting"] },
      { day: 3, title: "To Switzerland", activities: ["Travel to Swiss Alps", "Check-in", "Mountain views"] },
      { day: 4, title: "Swiss Adventure", activities: ["Swiss Alps Tour", "Cable car ride", "Alpine dinner"] },
      { day: 5, title: "To Italy", activities: ["Travel to Venice", "Gondola Ride", "Italian dinner"] },
      { day: 6, title: "Venice & Rome", activities: ["Venice exploration", "Travel to Rome", "Evening walk"] },
      { day: 7, title: "Rome", activities: ["Museum Visits", "Castle Tours", "City Walking Tours"] },
      { day: 8, title: "To Barcelona", activities: ["Flight to Barcelona", "Barcelona Gothic Quarter", "Tapas dinner"] },
      { day: 9, title: "Barcelona", activities: ["City Walking Tours", "Beach time", "Flamenco show"] },
      { day: 10, title: "To Amsterdam", activities: ["Flight to Amsterdam", "Amsterdam Bike Tour", "Canal cruise"] },
      { day: 11, title: "Amsterdam", activities: ["Museum Visits", "City exploration", "Farewell dinner"] },
      { day: 12, title: "Departure", activities: ["Leisurely breakfast", "Last shopping", "Airport transfer"] }
    ]
  },
  {
    id: 6,
    destinationId: 4,
    name: "Singapore Family Fun",
    duration: "4 Days",
    days: [
      { day: 1, title: "Theme Park Day", activities: ["Airport pickup", "Universal Studios", "Dinner at Sentosa"] },
      { day: 2, title: "Nature & Wonder", activities: ["Singapore Zoo", "Night Safari", "Hawker Center Food Tour"] },
      { day: 3, title: "City Highlights", activities: ["Gardens by the Bay", "Marina Bay Sands", "River Cruise"] },
      { day: 4, title: "Departure", activities: ["Merlion Park", "Little India Walk", "Airport transfer"] }
    ]
  },
  {
    id: 7,
    destinationId: 5,
    name: "Nepal Adventure",
    duration: "7 Days",
    days: [
      { day: 1, title: "Kathmandu Arrival", activities: ["Airport pickup", "Temple Visits", "Welcome dinner"] },
      { day: 2, title: "Cultural Day", activities: ["Temple Visits", "Meditation Retreat intro", "Local markets"] },
      { day: 3, title: "To Pokhara", activities: ["Travel to Pokhara", "Pokhara Lake Tour", "Sunset views"] },
      { day: 4, title: "Adventure Day", activities: ["Sunrise at Sarangkot", "Paragliding", "Lake activities"] },
      { day: 5, title: "Chitwan", activities: ["Travel to Chitwan", "Chitwan Safari", "Jungle camp"] },
      { day: 6, title: "Wildlife & Return", activities: ["Morning safari", "Return to Kathmandu", "Farewell dinner"] },
      { day: 7, title: "Departure", activities: ["Helicopter Tour", "Last shopping", "Airport transfer"] }
    ]
  },
  {
    id: 8,
    destinationId: 6,
    name: "Sri Lanka Explorer",
    duration: "6 Days",
    days: [
      { day: 1, title: "Colombo Arrival", activities: ["Airport pickup", "City tour", "Welcome dinner"] },
      { day: 2, title: "Sigiriya & Dambulla", activities: ["Sigiriya Rock", "Cave temples", "Evening at hotel"] },
      { day: 3, title: "Kandy", activities: ["Temple of Tooth", "Tea Plantation Tour", "Cultural dance show"] },
      { day: 4, title: "Scenic Train to Ella", activities: ["Scenic Train Ride", "Nine Arch Bridge", "Ella views"] },
      { day: 5, title: "Yala & Beach", activities: ["Yala National Park", "Travel to coast", "Beach Activities"] },
      { day: 6, title: "Departure", activities: ["Galle Fort Tour", "Stilt Fishermen", "Airport transfer"] }
    ]
  },
  {
    id: 9,
    destinationId: 7,
    name: "Malaysia Highlights",
    duration: "5 Days",
    days: [
      { day: 1, title: "KL Arrival", activities: ["Airport pickup", "Petronas Towers", "Welcome dinner"] },
      { day: 2, title: "City Tour", activities: ["KL Tower", "Batu Caves", "Chinatown"] },
      { day: 3, title: "Genting Highlands", activities: ["Skyworld Genting", "Cable car", "Casino visit"] },
      { day: 4, title: "Langkawi Island", activities: ["Flight to Langkawi", "Langkawi Cable Car", "Island Hopping"] },
      { day: 5, title: "Departure", activities: ["Beach morning", "Duty-free shopping", "Airport transfer"] }
    ]
  },
  {
    id: 10,
    destinationId: 8,
    name: "Vietnam Discovery",
    duration: "8 Days",
    days: [
      { day: 1, title: "Hanoi Arrival", activities: ["Airport pickup", "Old Quarter walk", "Water Puppet Show"] },
      { day: 2, title: "Ha Long Bay", activities: ["Ha Long Bay Cruise", "Kayaking", "Overnight on cruise"] },
      { day: 3, title: "To Hoi An", activities: ["Flight to Da Nang", "Transfer to Hoi An", "Hoi An Old Town"] },
      { day: 4, title: "Hoi An", activities: ["Cooking Class", "Tailoring", "Lantern night"] },
      { day: 5, title: "To Ho Chi Minh", activities: ["Flight to HCMC", "City orientation", "Street Food Tour"] },
      { day: 6, title: "History & Culture", activities: ["Cu Chi Tunnels", "War Remnants Museum", "Rooftop bar"] },
      { day: 7, title: "Mekong Delta", activities: ["Mekong Delta Tour", "Floating markets", "Fruit gardens"] },
      { day: 8, title: "Departure", activities: ["Ben Thanh Market", "Last pho", "Airport transfer"] }
    ]
  }
];

export const services = [
  {
    id: 1,
    title: "Honeymoon Packages",
    description: "Romantic getaways tailored for couples seeking unforgettable experiences",
    features: ["Private transfers", "Romantic dinners", "Luxury accommodations", "Special arrangements"]
  },
  {
    id: 2,
    title: "Family & Friends Group Tours",
    description: "Create lasting memories with your loved ones on customized group adventures",
    features: ["Group discounts", "Flexible itineraries", "All-inclusive packages", "Expert guides"]
  },
  {
    id: 3,
    title: "Adventure & Leisure Trips",
    description: "Perfect blend of thrill and relaxation for the ultimate travel experience",
    features: ["Adventure activities", "Leisure time", "Cultural experiences", "Customizable plans"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rahul & Priya Sharma",
    location: "Mumbai",
    rating: 5,
    text: "Our Bali honeymoon was absolutely magical! The Navkar Travels handled everything perfectly, from flights to romantic dinners. Highly recommend!",
    tripType: "Honeymoon - Bali"
  },
  {
    id: 2,
    name: "Amit Patel",
    location: "Ahmedabad",
    rating: 5,
    text: "Best family trip ever! Dubai was amazing and the itinerary was perfectly planned for our group of 8. Kids had a blast at all the attractions.",
    tripType: "Family Tour - Dubai"
  },
  {
    id: 3,
    name: "Sneha Reddy",
    location: "Hyderabad",
    rating: 5,
    text: "The Europe tour exceeded all expectations. Every detail was taken care of, and the custom itinerary matched our budget perfectly. Thank you TVL team!",
    tripType: "Group Tour - Europe"
  }
];

export const whyChooseUs = [
  {
    title: "Custom Itineraries",
    description: "Every trip is tailored to your preferences, interests, and budget"
  },
  {
    title: "Budget Friendly",
    description: "Get the best value with packages designed for every budget"
  },
  {
    title: "24/7 Support",
    description: "Round-the-clock assistance throughout your journey"
  },
  {
    title: "Expert Guidance",
    description: "Years of experience in crafting unforgettable travel experiences"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800",
    caption: "Beach Paradise"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=800",
    caption: "Mountain Adventures"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1503220317375-aaad61436b1b?w=800",
    caption: "City Explorations"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800",
    caption: "Scenic Views"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1504150558240-0b4fd8946624?w=800",
    caption: "Cultural Experiences"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=800",
    caption: "Tropical Destinations"
  }
];
